/**
 * Fixed notice copy of the links screens (1.J deliverable 3, `noticeFor`). Never document text:
 * a notice names no title, label, note or context.
 */
export const DUPLICATE_NOTICE =
  'That page was already in this list. Both links are kept; remove one if you like.';
export const ROW_CONFLICT_KEPT_TEXT =
  'This link changed elsewhere. Your text is kept; save again to replace it.';
export const ROW_CONFLICT_KEPT_DATES_TEXT =
  'This link changed elsewhere. Your dates are kept; save again to replace them.';
export const CYCLE_NOT_HOME_NOTICE = "Added, but this page is inside it, so it can't be its home.";
export const CREATED_NOT_PLACED_NOTICE =
  "The new page was created but couldn't be placed. It's at the top of the tree.";

const NOTICES: Readonly<Record<string, string>> = {
  row_conflict: 'This link changed elsewhere. The list is refreshed.',
  document_trashed: "That page is in the trash, so the link couldn't be changed.",
  link_cycle: "That page is inside this one, so it can't be its home.",
  primary_not_structural: "Only a contains link can be a page's home.",
  reference_read_only: 'Reference pages are read-only.',
  not_found: 'That page or link no longer exists.',
  network: "The change couldn't be sent. Check the connection and try again.",
  duplicate: DUPLICATE_NOTICE,
};

const FALLBACK = "That didn't work. Try again.";

/** The notice for an error code (an `ApiError`'s `code`, `'network'`, or `'duplicate'`). */
export function noticeFor(code: string | undefined): string {
  return (code !== undefined && NOTICES[code]) || FALLBACK;
}

export function removedNotice(title: string): string {
  return `Removed ${title} from this page.`;
}

export function movedAnnouncement(title: string, position: number, count: number): string {
  return `Moved ${title} to position ${position} of ${count}.`;
}
